import React, { useState, useEffect } from "react";
import CareEconomyModel from "../ModelLayouts/CareEconomyModel";
import CareEconomyPopup from "../../components/PopUps/CareEconomyPopup";
import { Link } from "react-router-dom";
import WhatIsCare from "../DetailsSubSections/CareEconomy/WhatIsCare";
import CareMatter from "../DetailsSubSections/CareEconomy/CareMatter";
import StrongCare from "../DetailsSubSections/CareEconomy/StrongCare";
import SchemesAndPolicies from "../DetailsSubSections/CareEconomy/SchemesAndPolicies";
import CareScenarios from "../DetailsSubSections/CareEconomy/CareScenarios";
import Icon from "../ui/Icon";
import FootInfo from "../ui/FootInfo";
import Magnifier from "../ui/Magnifier";
import CareEconomyMobileModel from "../ModelLayouts/CareEconomyMobileModel";

const CareEconomyDetail = ({ isTabLoading }) => {
  const [showInfo, setShowInfo] = useState(false);
  const [isAutoOpen, setIsAutoOpen] = useState(false);
  const [clickOrigin, setClickOrigin] = useState("center right");
  const aboutIconRef = React.useRef(null);

  useEffect(() => {
    const hasViewed = sessionStorage.getItem("viewed_care_economy_popup");
    if (!hasViewed) {
      if (aboutIconRef.current) {
        const rect = aboutIconRef.current.getBoundingClientRect();
        setClickOrigin(
          `${rect.left + rect.width / 2}px ${rect.top + rect.height / 2}px`,
        );
      }
      setShowInfo(true);
      setIsAutoOpen(true);
      sessionStorage.setItem("viewed_care_economy_popup", "true");
    }
  }, []);

  const handleClose = () => {
    setShowInfo(false);
  };

  const handleExplore = () => {
    setShowInfo(false);
  };

  const handleManualOpen = (e) => {
    if (e && e.currentTarget) {
      const rect = e.currentTarget.getBoundingClientRect();
      setClickOrigin(
        `${rect.left + rect.width / 2}px ${rect.top + rect.height / 2}px`,
      );
    } else {
      setClickOrigin("center right");
    }
    setIsAutoOpen(false);
    setShowInfo(true);
  };

  const scrollToSectionEnd = () => {
    const element = document.getElementById("read-more-section");
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <div>
      <div className="mb-10 lg:mb-40">
        <div className="flex items-center justify-between mt-2 lg:hidden">
          <img
            src="/assets/svgs/countrys.svg"
            alt="Countries"
            className="w-auto h-auto [zoom:0.7]"
          />
          <div className="flex gap-3">
            <button ref={aboutIconRef} onClick={handleManualOpen}>
              <Icon src="/assets/svgs/about.svg" alt="About" />
            </button>
            <button onClick={scrollToSectionEnd}>
              <Icon
                src="/assets/svgs/back_btn.svg"
                alt="Bottom button"
                className="-rotate-90"
              />
            </button>
          </div>
        </div>

        <section className="block lg:hidden">
          <div className="">
            {/* <img
              src="/assets/img/mobile-layout/mobile-care-economy.png"
              alt="Care economy mobile"
            /> */}
            <CareEconomyMobileModel
              className="[zoom:0.55] xs:[zoom:0.7] sm:[zoom:1]"
              isParentLoading={isTabLoading}
              isPopUpOpen={showInfo}
            />
          </div>
        </section>

        <section className="relative hidden lg:block">
          <CareEconomyModel className="[zoom:0.7] xl:[zoom:1]" />
          <div className="absolute top-[67%] -translate-y-1/2 right-5 z-10">
            <div className="flex gap-3">
              <button ref={aboutIconRef} onClick={handleManualOpen}>
                <Icon src="/assets/svgs/about.svg" alt="About" />
              </button>
              <button onClick={scrollToSectionEnd}>
                <Icon
                  src="/assets/svgs/back_btn.svg"
                  alt="Bottom button"
                  className="-rotate-90"
                />
              </button>
            </div>
          </div>
        </section>
      </div>

      <section
        className="grid lg:grid-cols-2 gap-5 scroll-mt-24"
        id="read-more-section"
      >
        <div className="hidden lg:block lg:col-span-1 h-fit sticky top-24 self-start">
          <div className="relative">
            <div className="[zoom:0.6] xl:[zoom:0.75] 2xl:[zoom:0.8]">
              <Magnifier
                zoomScale={3}
                lensSize={180}
                zoomPanelClassName="w-[800px] 1xl:w-[890px] 2xl:w-[1020px] h-[900px]"
              >
                <CareEconomyModel
                  className="[zoom:0.6] 1xl:[zoom:0.7] 2xl:[zoom:0.8]"
                  showTooltips={false}
                />
              </Magnifier>
            </div>
            <div>
              <div className="absolute left-0 xl:-bottom-16 [zoom:0.7] xl:[zoom:0.8]">
                {/* Country image at top */}
                <img
                  src="/assets/svgs/countrys.svg"
                  alt="Countries"
                  className="w-auto h-auto"
                />
              </div>
              <div className="absolute -bottom-10 right-5 z-10">
                <Link to="/zoom-in-care-economy">
                  <Icon
                    src="/assets/svgs/zoomIn_btn.svg"
                    alt="Zoom in button"
                  />
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-1">
          <div className="space-y-12">
            <WhatIsCare />
            <CareMatter />
            <StrongCare />
            <SchemesAndPolicies />
            <CareScenarios />
            <FootInfo />
          </div>
        </div>
      </section>

      <CareEconomyPopup
        open={showInfo}
        onClose={handleClose}
        onExplore={handleExplore}
        transformOrigin={clickOrigin}
      />
    </div>
  );
};

export default CareEconomyDetail;
